import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';

export const GET_FRONTEND_CONFIG_URL = `${BUSINESS_PAYMENT_PREFIX}/account/frontend-configs`;

export const getProductConfigs = () =>
  axios.get(`${BUSINESS_PAYMENT_PREFIX}/account/configs`, {
    disableToast: true,
  });

export const getFrontendConfigs = () =>
  axios.get(GET_FRONTEND_CONFIG_URL, {
    disableToast: true,
  });
